export default __webpack_public_path__ + "static/media/ManipalLogo.2ba674ce.png";